module.exports = __webpack_public_path__ + "static/media/m5.e2afe852.png";